<template>
  <wui-btn
    v-bind="$attrs"
    @click="downloadIcs()"
  >
    {{ $t('common.downloadInvitation') }}
  </wui-btn>
</template>
<script setup lang="ts">
import { WuiBtn } from '@wui/common-library'
import { IcsEvent } from 'ts-ics'
import { toRef } from 'vue'

import { useScheduleDownloadIcs } from '../lib'

const props = defineProps<{
  schedule: IcsEvent
}>()

const schedule = toRef(props, 'schedule')

const { downloadIcs } = useScheduleDownloadIcs(schedule)
</script>
